import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import type { SVGProps } from "react";
import { buttonVariants } from "@/components/ui/button";

function HospitalIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			{...props}
			fill="none"
			height="24"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Aplicación de Gestión de Pacientes</title>
			<path d="M12 6v4" />
			<path d="M14 14h-4" />
			<path d="M14 18h-4" />
			<path d="M14 8h-4" />
			<path d="M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2" />
			<path d="M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18" />
		</svg>
	);
}

export const Route = createFileRoute("/(marketing)")({
	component: () => (
		<div className="flex min-h-dvh flex-col">
			<header className="flex items-center bg-primary px-4 pt-8 lg:px-8">
				<Link className="flex items-center justify-center" to="/">
					<HospitalIcon className="h-6 w-6 text-primary-foreground" />
					<span className="sr-only">Aplicación de Gestión de Pacientes</span>
				</Link>

				<nav className="ml-auto flex items-center gap-4 sm:gap-6">
					<a
						className="font-medium text-primary-foreground text-sm underline-offset-4 hover:underline"
						href="/#caracteristicas"
					>
						Características
					</a>
					<a
						className="font-medium text-primary-foreground text-sm underline-offset-4 hover:underline"
						href="/#precios"
					>
						Precios
					</a>
					<a
						className="font-medium text-primary-foreground text-sm underline-offset-4 hover:underline"
						href="/#contacto"
					>
						Contacto
					</a>

					<Link
						className={buttonVariants({
							variant: "secondary",
						})}
						to="/auth/login"
					>
						Acceder
					</Link>
				</nav>
			</header>

			<main className="flex-1">
				<Outlet />
			</main>

			<footer className="flex flex-col items-center gap-2 bg-primary px-4 py-6 sm:flex-row md:px-6">
				<p className="text-primary-foreground text-xs">
					&copy; 2024 Aplicación de Gestión de Pacientes. Todos los derechos reservados.
				</p>
				<nav className="flex gap-4 sm:ml-auto sm:gap-6">
					<a className="text-primary-foreground text-xs underline-offset-4 hover:underline" href="/#terminos">
						Términos de Servicio
					</a>
					<a className="text-primary-foreground text-xs underline-offset-4 hover:underline" href="/#privacidad">
						Política de Privacidad
					</a>
				</nav>
			</footer>
		</div>
	),
});
